define(function (require, exports, module) {
    var ContentModel = require('./ContentModel');
    var classify = require('es6ish-class/es6ish-class');
    var Superclass;

    var MEDIA_ARCHIVE = 'MEDIA_ARCHIVE';
    var MEDIA_TYPE = 'media-type';
    var PLAYBACK_SCENARIO = 'playback-scenario';
    var ASPECT_RATIO = '16:9';
    var r_protocol = /^http/;
    var HTTPS = 'https';

    var thumbToCutMap = {
        '43': {
            width: 640,
            height: 360
        },
        '44': {
            width: 320,
            height: 180
        },
        '45': {
            width: 1280,
            height: 720
        },
        '48': {
            width: 960,
            height: 540
        }
    };

    function findUsableThumbs (thumb) {
        return thumb && thumbToCutMap[thumb.type] && thumb._text;
    }

    function convertThumbnailsToCuts (thumb) {
        var cut = thumbToCutMap[thumb.type];
        var src = thumb._text && thumb._text.replace(r_protocol, HTTPS);

        return {
            aspectRatio: ASPECT_RATIO,
            width: cut.width,
            height: cut.height,
            src: src,
            at2x: src,
            at3x: src
        };
    }

    function convertUrlToPlayback (url) {
        var name = url && url[PLAYBACK_SCENARIO];
        if (name && url._text) {
            url.name = name;
            url.url = url._text;
            delete url._text;
            delete url[PLAYBACK_SCENARIO];
            delete url._nodeName;
            return true;
        }
        return false;
    }

    function convertOldHighlight (highlight) {
        var thumbs = highlight.thumbnails && highlight.thumbnails.thumb;
        var keywords = highlight.keywords && highlight.keywords.keyword;
        var playbackScenarios = highlight.url;

        return {
            type: highlight.type,
            'date': highlight.date,
            'id': highlight.id,
            'title': highlight.headline,
            'headline': highlight.headline,
            'blurb': highlight.blurb,
            'description': highlight.bigblurb,
            'authFlow': false,
            'duration': highlight.duration,
            'mediaState': MEDIA_ARCHIVE,
            'guid': highlight.playId,
            image: {
                cuts: thumbs && thumbs.filter(findUsableThumbs).map(convertThumbnailsToCuts) || []
            },
            keywordsAll: keywords || [],
            mediaType: highlight[MEDIA_TYPE],
            playbacks: playbackScenarios && playbackScenarios.filter(convertUrlToPlayback) || []
        };
    }

    function fakeItTilCMSMakesIt (oldHighlights) {
        var videoItems = [];
        var rawHighlights = oldHighlights && oldHighlights.highlights && oldHighlights.highlights.media || [];
        var responseHighlights = {};
        var highlights = responseHighlights.highlights = {};
        var live = highlights.live = {};
        var media = responseHighlights.media = {};
        var epg = media.epg = [];

        if (rawHighlights.length) {
            var allVideoItems = rawHighlights.map(convertOldHighlight);
            if (allVideoItems && allVideoItems.length) {
                var len = allVideoItems.length;
                var i = 0;
                var highlight;

                for (; i < len; i++) {
                    highlight = allVideoItems[i];
                    if (highlight.mediaType === 'C') {
                        epg.push({
                            title: 'Extended Highlights',
                            items: [highlight]
                        });
                        continue;
                    }
                    if (highlight.mediaType === 'R') {
                        epg.push({
                            title: 'Daily Recap',
                            items: [highlight]
                        });
                        continue;
                    }
                    videoItems.push(highlight);
                }
            }
            videoItems.reverse();
        }

        live.items = videoItems;
        return responseHighlights;
    }

    function LiesContentModel (data) {
        var sortOfData = fakeItTilCMSMakesIt(data);

        Superclass.constructor.call(this, sortOfData);
    }

    classify(LiesContentModel).extendsFrom(ContentModel);

    Superclass = LiesContentModel.superclass;
    return LiesContentModel;
});
